import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { dataportfolio, shortformportfolio, animationportfolio } from "../../content_option";
import PerspectiveVideoCarousel from "./PerspectiveVideoCarousel";

export const Portfolio = () => (
  <section id="portfolio" className="About-header">
    <Container>
      <Row className="mb-4 mt-3 pt-md-3">
        <Col lg="8">
          <h1 className="display-4 mb-4">Portfolio</h1>
          <hr className="t_border my-4 ml-0 text-left" />
          <h2 className="color_sec ab_heading">AI Video Production</h2>
          <p className="po_subtitle">
            Cinematic videos created with cutting-edge AI tools.
          </p>
        </Col>
      </Row>
      <PerspectiveVideoCarousel items={dataportfolio} />
      <div className="po_subsection mt-5">
        <h2 className="color_sec ab_heading">Short Form Videos</h2>
        <p className="po_subtitle">Quick and engaging short-form videos.</p>
        <PerspectiveVideoCarousel items={shortformportfolio} />
      </div>
      <div className="po_subsection mt-5">
        <h2 className="color_sec ab_heading">2D Animation Videos</h2>
        <p className="po_subtitle">
          Creative 2D animated videos for various campaigns.
        </p>
        <PerspectiveVideoCarousel items={animationportfolio} />
      </div>
    </Container>
  </section>
);
